/**
 * The timeline palette, in ONE place.
 *
 * ── THESE ARE THE SOURCE'S VALUES, COPIED ─────────────────────────────────────────────
 *
 * Every hex below is `ai_readiness_template/views/roadmap-execution/finalization.ejs`:
 * `PHASE_COLORS` at line 149 and `mvpColor`'s palette at line 234. Nothing here is chosen.
 *
 * This file previously held a STRONGER set (`#42a5f5`, `#ab47bc`, `#66bb6a`, `#ffa726`,
 * `#ef5350`) carried over from the original port. They were flagged as a deviation and the
 * owner ruled for the source's: "implement the same color IDs in this app as it is done in
 * AI Readiness app". The pastels also read better behind the grey non-working-day overlay,
 * which is drawn ON TOP of each bar.
 *
 * Both the Gantt bars and the phase dots in the tables import from here, so a phase is the
 * same colour wherever it appears.
 */

/** The five Waterfall phases — `finalization.ejs:149`. */
export const PHASE_COLORS: Record<string, string> = {
  Assessment_Planning: '#90caf9',
  Design_Architecture: '#ce93d8',
  Development: '#a5d6a7',
  Testing_Validation: '#ffcc80',
  GoLive_Optimization: '#ef9a9a',
};

/** The MVP palette, cycled — `finalization.ejs:234`. */
export const MVP_PALETTE = [
  '#00838f', '#1565c0', '#6a1b9a', '#ef6c00', '#2e7d32',
  '#5e35b1', '#c62828', '#00897b', '#7cb342', '#3949ab',
];

export const mvpColor = (i: number) => MVP_PALETTE[i % MVP_PALETTE.length]!;

/**
 * A phase-less ("None") initiative's single bar.
 *
 * The source keys this as `PHASE_COLORS.Flat_Delivery` and sets it to the SAME value as
 * Assessment & Planning — `#90caf9`. Derived rather than retyped, so the two cannot drift.
 */
export const FLAT_COLOR = PHASE_COLORS.Assessment_Planning!;
